// src/utils/employeeCSVExport.js
// or 
// src/pages/employee/employeelist/employeeCSVExport.js

/**
 * Creates and downloads a CSV file from employee data
 * @param {Array} employeeExportData - Array of employee data
 * @param {Array} branchList - List of branches for mapping branch IDs
 * @param {string} orgInitials - Organization initials for file naming
 */
export const exportEmployeeDataToCSV = (employeeExportData, branchList, orgInitials) => {
    // Define CSV headers
    const headers = [
      "SL No.",
      "Employee Code",
      "Name",
      "Phone",
      "Gender",
      "Date of Birth",
      "Date of Join",
      "Designation",
      "Department",
      "Branch",
      "Guardian Name",
      "Salary Type",
      "ESI Number",
      "UAN",
      "Gross Salary",
      "OT Rate"
    ];
    
    // Format the employee data for CSV
    const csvData = employeeExportData.map((employee, index) => {
      // Find branch name
      const branchName = employee?.branch_id
        ? branchList?.find(branch => branch?.id === employee?.branch_id)?.name || "--"
        : "--";
        
      return [
        index + 1,
        employee?.employee_code || "--",
        `${employee?.first_name || ""} ${employee?.last_name || ""}`.trim() || "--",
        employee?.phone || "--",
        employee?.gender || "--",
        employee?.date_of_birth ? new Date(employee?.date_of_birth).toLocaleDateString() : "--",
        employee?.join_date ? new Date(employee?.join_date).toLocaleDateString() : "--",
        employee?.designation?.designation_name || "--",
        employee?.department?.dept_name || "--",
        branchName,
        employee?.guardian_name || "--",
        employee?.salary_type ? employee?.salary_type.toUpperCase() : "--",
        employee?.esic_insurance_number || "--",
        employee?.uan_no || "--",
        employee?.salary_info?.gross_salary ? `₹${employee?.salary_info?.gross_salary.toFixed(2)}` : "₹0.00",
        employee?.benefits?.ot_rate ? `₹${employee?.benefits?.ot_rate.toFixed(2)}` : "₹0.00"
      ];
    });
    
    // Combine headers and data
    const csvContent = [
      headers.join(","),
      ...csvData.map(row => row.map(cell => {
        // If the cell contains a comma, wrap it in quotes
        return cell.toString().includes(",") ? `"${cell}"` : cell;
      }).join(","))
    ].join("\n");
    
    // Create a Blob with the CSV data
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    
    // Create a temporary download link
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    
    // Set the file name
    const fileName = `${orgInitials}-Employee-List.csv`;
    
    // Configure and trigger download
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };